import { render, staticRenderFns } from "./fansRecord.vue?vue&type=template&id=60b9d292&scoped=true"
import script from "./fansRecord.vue?vue&type=script&lang=js"
export * from "./fansRecord.vue?vue&type=script&lang=js"
import style0 from "./fansRecord.vue?vue&type=style&index=0&id=60b9d292&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b9d292",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b9d292')) {
      api.createRecord('60b9d292', component.options)
    } else {
      api.reload('60b9d292', component.options)
    }
    module.hot.accept("./fansRecord.vue?vue&type=template&id=60b9d292&scoped=true", function () {
      api.rerender('60b9d292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/components/fansRecord.vue"
export default component.exports